export enum MemberSetTypeEnum {
  Unknown = "Unknown",

  Census = "Census",

  Full = "Full",
}

export enum MemberSetVersionStatus {
  Created = "created",

  Processing = "processing",

  Activated = "activated",

  Archived = "archived",

  FailedUpload = "failedUpload"
}
